import { render, staticRenderFns } from "./masonary-desc.vue?vue&type=template&id=53f56e90&"
import script from "./masonary-desc.vue?vue&type=script&lang=js&"
export * from "./masonary-desc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports